import { createSelector } from '@reduxjs/toolkit';

import { countPendingInvites } from '../../domain/events/participants';
import type { RootState } from '../store';

export const selectPendingInvitesCount = createSelector(
  [(s: RootState) => s.auth.user?.telegramId, (s: RootState) => s.entities.events.items],
  (telegramId, events) => {
    return countPendingInvites(events, telegramId ?? '');
  },
);
